<template>
  <div class="trip-main">
    <div class="trip-data">
      <div class="content-block" v-for="(route, index) in editableRoutes" :key="route.id">
        <p class="font-16 marginbottom-15"><strong>Тип операции:</strong> {{ route.operation_type }}</p>
        <div class="marginbottom-15">
          <p><strong>Склад:</strong> {{ route.warehouse_name }}</p>
          <p><strong>Адрес:</strong> {{ route.address }}</p>
          <p v-if="route.correct_planned_datetime || route.planned_date">
            <strong>План:</strong> {{ placeTime(route.correct_planned_datetime || route.planned_date, route.timezone) }}
          </p>
          <p v-if="route.arrival_time">
            <strong>Факт прибытия:</strong> {{ placeTime(route.arrival_time, route.timezone) }}
          </p>
          <p v-if="route.timezone" class="tz-hint">Время площадки; в скобках — по Ульяновску.</p>
        </div>
        
        <template v-if="route.operation_type === 'Oтгрузка'">
          <div class="form-group">
            <label>Контакт погрузки:</label>
            <input 
              type="text" 
              v-model="route.loading_contact" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            />
          </div>
          <div class="form-group">
            <label>Способ погрузки:</label>
            <input 
              type="text" 
              v-model="route.loading_method" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            />
          </div>
          <div class="form-group">
            <label>Дополнительно:</label>
            <textarea 
              type="text" 
              v-model="route.loading_additional_info" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            ></textarea>
          </div>
          <div class="form-group">
            <label>Плановая дата:</label>
            <input
              type="datetime-local"
              v-model="route.correct_planned_datetime"
              @input="markAsChanged(index)"
              class="form-control"
            />
          </div>
        </template>
        <template v-else-if="route.operation_type === 'Выгрузка'">
          <div class="form-group">
            <label>Контакт выгрузки:</label>
            <input 
              type="text" 
              v-model="route.unloading_contact" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            />
          </div>
          <div class="form-group">
            <label>Способ выгрузки:</label>
            <input 
              type="text" 
              v-model="route.unloading_method" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            />
          </div>
          <div class="form-group">
            <label>Дополнительно:</label>
            <textarea 
              type="text" 
              v-model="route.unloading_additional_info" 
              placeholder="Не указано" 
              @input="markAsChanged(index)"
            ></textarea>
          </div>
          <div class="form-group">
            <label>Плановая дата:</label>
            <input
              type="datetime-local"
              v-model="route.correct_planned_datetime"
              @input="markAsChanged(index)"
              class="form-control"
            />
          </div>
        </template>
      </div>
    </div>
    <!-- Кнопка сохранения -->
    <button 
      :disabled="!hasChanges" 
      @click="saveChanges"
      class="save-button"
    >
      Сохранить
    </button>
  </div>
</template>


<script>
import { computed, ref, watch } from 'vue';
import { formatPlaceTime } from '../helpers/placeTime.mjs';

export default {
  name: 'RoutePointInfo',
  props: ['routes'],

  setup(props, {emit}) {
    // Создаем глубокую копию маршрутов для редактирования
    const editableRoutes = ref(
      JSON.parse(JSON.stringify(props.routes)).sort((a, b) => new Date(a.planned_date) - new Date(b.planned_date))
    );
    
    const hasChanges = ref(false); // Флаг для отслеживания изменений

    // Отслеживание изменений в маршрутах
    const markAsChanged = (index) => {
      if (JSON.stringify(props.routes[index]) !== JSON.stringify(editableRoutes.value[index])) {
        hasChanges.value = true;
      } else {
        hasChanges.value = editableRoutes.value.some(
          (route, i) => JSON.stringify(props.routes[i]) !== JSON.stringify(route)
        );
      }
    };

    // Сброс изменений
    const resetChanges = () => {
      editableRoutes.value = JSON.parse(JSON.stringify(props.routes));
      hasChanges.value = false;
    };

    // Сохранение изменений
    const saveChanges = () => {
      emit('updateRouteInfo', editableRoutes.value)
      emit('forceInput')
      // Здесь можно добавить логику отправки данных на сервер
      resetChanges(); // Сбрасываем флаг изменений
    };

    // Сброс при изменении пропсов (например, при обновлении маршрутов)
    watch(
      () => props.routes,
      (newRoutes) => {
        editableRoutes.value = JSON.parse(JSON.stringify(newRoutes));
        hasChanges.value = false;
      }
    );

    const placeTime = (value, timeZone) => formatPlaceTime(value, timeZone) || '—';

    return {
      placeTime,
      editableRoutes,
      hasChanges,
      markAsChanged,
      saveChanges,
    };
  },
};
</script>

<style scoped>
.trip-main{
  margin-top: 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 20px;
}

.trip-data {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.content-block {
  min-width: 350px;
  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  font-size: 13px;
}

.tz-hint {
  color: #6b7280;
  font-size: 12px;
}

.form-group {
  display: grid;
  grid-template-columns: 125px 1fr;
  align-items: center;
  margin-bottom: 5px;
}

.form-group label {
  font-weight: bold;
}

input,textarea {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 100%;
}

.save-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>